var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('shopping-cart',{on:{"editCartItem":_vm.edit_cart_item}}),(_vm.isShowProduct)?_c('product-modal',{attrs:{"data_item":_vm.modal_item,"cart-item-index":_vm.modal_cart_item_index},on:{"close":_vm.closeModal}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }